// Matches rteh's src/constants/pricing.ts formatting exactly, so the same amount looks
// identical whether the customer sees it on the website or (as admin/driver) in the app.
export function fmt(amount: number): string {
  return `J$${amount.toLocaleString('en-JM', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}
